import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// --- Configuration Axios ---
const templateApi = axios.create({
  baseURL: API_BASE_URL,
  responseType: 'blob',
  headers: { 'Content-Type': 'application/json' },
});

// --- Intercepteurs ---
templateApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

templateApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// --- Utilitaires ---
const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Extraction du nom de fichier si présent dans la réponse HTTP
const getFilenameFromHeader = (response, defaultName) => {
  const disposition = response.headers['content-disposition'];
  if (disposition && disposition.includes('filename=')) {
    return disposition.split('filename=')[1].split(';')[0].replace(/['"]/g, '');
  }
  return defaultName;
};

// Fonction générique pour télécharger un template
const downloadTemplate = async (endpoint, defaultName, errorMessage) => {
  try {
    const response = await templateApi.get(endpoint);
    return { success: true, data: response.data, response };
  } catch (error) {
    console.error(errorMessage, error);
    return { success: false, error: errorMessage };
  }
};

// --- Service principal ---
export const templateService = {
  downloadProductsTemplate: () =>
    downloadTemplate('/export/products/template', 'produits', 'Erreur téléchargement produits'),

  downloadCategoriesTemplate: () =>
    downloadTemplate('/export/categories/template', 'categories', 'Erreur téléchargement catégories'),

  downloadBlogsTemplate: () =>
    downloadTemplate('/export/blogs/template', 'blogs', 'Erreur téléchargement blogs'),

  downloadQuotesTemplate: () =>
    downloadTemplate('/export/quotes/template', 'devis', 'Erreur téléchargement devis'),

  downloadImportTemplate: () =>
    downloadTemplate('/export/products/template-with-dropdowns', 'produits', 'Erreur téléchargement template'),

  downloadAllTemplates: async () => {
    // Pour downloadAllTemplates, on télécharge seulement le template des produits
    // car c'est le plus couramment utilisé
    return downloadTemplate('/export/products/template-with-dropdowns', 'produits', 'Erreur téléchargement template');
  },
};

export default templateService;
